import { customAxios, customFileDownAxios } from "./customAxios";

/**
 * 파일 다운로드
 * @param {*} fid 
 * @returns 
 */
export const getDownloadByFid = async(fid)=>{
    const res = await customFileDownAxios.get('/api/download/'+fid);
    //console.log(res);
    if (res) {
        return res.data;
    }
    return null;
}

/**
 * 수명예측 csv, 결함동영상 파일 다운로드
 * @param {*} query 
 * @returns 
 */
export const getDownloadDirectByQuery = async(query)=>{
    const res = await customFileDownAxios.get('/api/download/:direct',{params: query});
    //console.log(res);
    if (res) {
        return res.data;
    }
    return null;
}

/**
 * 자료실 목록
 * @param {*} query 
 * @returns 
 */
export const getFileManagersByQuery = async(query)=>{
    const res = await customAxios.get('/api/fileManagers', {params : query});
    //console.log(res);
    if (res.data) {
        return res.data;
    }
    return null;
}

/**
 * 파일 상세
 * @param {*} query 
 * @returns 
 */
export const getFileManagersById = async(id)=>{
    const res = await customAxios.get('/api/fileManagers/'+id);
    //console.log(res);
    if (res.data) {
        return res.data;
    }
    return null;
}


/**
 * 자료실 삭제
 * @param {*} param 
 */
export const deleteFileManagerById = async(id)=>{
    //console.log(id);
    await customAxios.delete('/api/fileManagers/'+id);
   }
   